import {
  ControlProps,
  isControl,
  NOT_APPLICABLE,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { DispatchCell, withJsonFormsControlProps } from "@jsonforms/react";
import maxBy from "lodash/maxBy";

import { Label } from "@/components/ui/label";

export const InputControl = (props: ControlProps) => {
  const {
    id,
    uischema,
    schema,
    label,
    rootSchema,
    enabled,
    visible,
    path,
    cells,
    config,
    description,
  } = props;

  const testerContext = {
    rootSchema: rootSchema,
    config: config,
  };
  const cell = maxBy(cells, (r) => r.tester(uischema, schema, testerContext));

  if (
    cell === undefined ||
    cell.tester(uischema, schema, testerContext) === NOT_APPLICABLE
  ) {
    console.warn("No applicable cell found.", uischema, schema);
    return null;
  } else {
    return (
      <div hidden={!visible} id={id}>
        {schema.type !== "boolean" && (
          <>
            {label && <Label htmlFor={id + "-input"}>{label}</Label>}
            <DispatchCell
              uischema={uischema}
              schema={schema}
              path={path}
              id={id + "-input"}
              enabled={enabled}
            />
          </>
        )}
        {schema.type === "boolean" && (
          <div className="flex items-center space-x-2">
            <DispatchCell
              uischema={uischema}
              schema={schema}
              path={path}
              id={id + "-input"}
              enabled={enabled}
            />
            {label && <Label htmlFor={id + "-input"}>{label}</Label>}
          </div>
        )}
        {description && (
          <p className="text-xs text-muted-foreground mt-2">{description}</p>
        )}
      </div>
    );
  }
};

export const inputControlTester: RankedTester = rankWith(2, isControl);

export default withJsonFormsControlProps(InputControl);
